export const generateRandomString = (length = 5) => {
  return Math.random().toString(36).substring(2, length);
};

export const convertToSnakeCase = (str: string) => {
  return str
    .replace(/([A-Z])/g, "_$1")
    .toLowerCase()
    .replace(/^_/, "") // Remove leading underscore
    .trim();
};
